import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchAfslAndModelAssociations, fetchStrategyAssociations } from './thunks';
import { Associations, StrategyAssociations } from './types';
import { fetchStrategyDashboard } from '../../common/store/thunks';

export const initialState: StrategyAssociations = {
  associations: null,
  afslId: 0,
  afslError: false,

  common: {
    strategyDashboard: null
  }
};

export const strategyAssociationsSlice = createSlice({
  name: '@@strategy/associations',
  initialState,
  reducers: {},
  extraReducers: (builder) => {

    builder.addCase(fetchAfslAndModelAssociations.pending, (state) => {
      state.afslError = false;
    });

    builder.addCase(
      fetchAfslAndModelAssociations.fulfilled,
      (state, action: PayloadAction<number>) => {
        state.afslId = action.payload;
        state.afslError = false;
      }
    );

    builder.addCase(fetchAfslAndModelAssociations.rejected, (state) => {
      state.afslError = true;
    });

    builder.addCase(fetchStrategyAssociations.fulfilled, (state, action: PayloadAction<Associations>) => {
      state.associations = action.payload;
    });

    builder.addCase(fetchStrategyDashboard.fulfilled, (state, action) => {
      state.common.strategyDashboard = action.payload;
    });
  },
});
